









































































import { ContactLensImageType } from '@/services/contact-lens-image-type/contact-lens-image-type-storage'
import { ListError } from '@hl-itemlist/model/list-error'
import { OTHER_PRODUCTS_LINKS, OtherProductsLink } from '@hl-itemlist/model/other-products-links'
import { ProductCard as ProductCardModel } from '@hl-itemlist/model/product-card'
import { ProductPriceView } from '@hl-itemlist/model/product-price'
import { isSpColumnCount, SP_COLUMN_FOUR, SP_COLUMN_THREE, SP_COLUMN_TWO } from '@hl-itemlist/model/sp-column-count'
import Vue, { PropType } from 'vue'
import ProductCard from './ProductCard.vue'

// 末尾に到達する少し手前で先読みを始めるためのマージン
const OBSERVER_ROOT_MARGIN = '240px'

export default Vue.extend({
  components: {
    ProductCard,
  },
  props: {
    /**
     * 表示中の一覧の条件にキーワード(q)が含まれるか。0件時の導線の出し分けに使う:
     * キーワード検索の0件は別キーワードの再入力(change-keyword)へ、
     * 絞り込みだけの0件は条件の変更(change-filters)へ誘導する。
     */
    hasKeyword: {
      type: Boolean,
      required: true,
    },
    imageType: {
      type: String as PropType<ContactLensImageType>,
      required: true,
    },
    /**
     * 一覧の取得エラー(取得の状態遷移はApp側の責務)。エラーUIはこのコンポーネントに一元化しており、
     * エラー中はオートロードを止めて再読み込みボタンからの手動再試行だけを受け付ける。
     */
    listError: {
      type: String as PropType<ListError>,
      required: true,
    },
    /**
     * 一覧(商品ページ)のいずれかのページを取得中か(1ページ目・追加ページの区別は持たない。
     * 区別はlistErrorの側が担う)。価格の取得中は含まない(価格は一覧と独立に後から埋まる。pricesのコメント参照)。
     */
    loading: {
      type: Boolean,
      required: true,
    },
    /**
     * 商品(FKU)id → 価格表示。価格は一覧とは別APIで後から埋まるため、取得未完了のidは含まれない
     * (取得完了後は「価格なし(￥-)」表示も含め必ず入る)。
     */
    prices: {
      type: Object as PropType<{ [fkuItemId: number]: ProductPriceView }>,
      required: true,
    },
    // 参照のみ(描画とlengthの判定)。ProductListStateの丸ごと差し替え運用に合わせてreadonlyで受ける
    products: {
      type: Array as PropType<ReadonlyArray<ProductCardModel>>,
      required: true,
    },
    reachedLast: {
      type: Boolean,
      required: true,
    },
    /**
     * スマホ表示時の列数(2/3/4)。PC表示は常に4列でこの値の影響を受けない。
     */
    spColumnCount: {
      type: Number,
      required: true,
      validator: isSpColumnCount,
    },
  },
  data(): { observer: IntersectionObserver | null } {
    return {
      observer: null,
    }
  },
  computed: {
    otherProductsLinks(): ReadonlyArray<OtherProductsLink> {
      return OTHER_PRODUCTS_LINKS
    },
    // 列数のクラスは常にいずれか1つが付く(スタイル側に「クラスなし=デフォルト列数」という暗黙の前提を持たせない)
    itemsClass(): { [key: string]: boolean } {
      return {
        'hl-item-grid__items--sp-column-2': this.spColumnCount === SP_COLUMN_TWO,
        'hl-item-grid__items--sp-column-3': this.spColumnCount === SP_COLUMN_THREE,
        'hl-item-grid__items--sp-column-4': this.spColumnCount === SP_COLUMN_FOUR,
      }
    },
  },
  watch: {
    // ページ追加はproductsの置き換えで届く。失敗時はproductsが変わらないので再発火せず、
    // 取得失敗の自動リトライループにはならない
    products(): void {
      this.rearmObserver()
    },
    // 列数変更でグリッドの高さが縮み、sentinelが画面内へ入ることがある
    spColumnCount(): void {
      this.rearmObserver()
    },
  },
  mounted() {
    if (!('IntersectionObserver' in window)) {
      return
    }

    const observerCallback = (entries: IntersectionObserverEntry[]) => {
      // 同一対象の交差変化は複数まとめて届きうる(entriesは時系列)。古いentryで判定すると、
      // 「非交差→交差」の並びで読み込みを取りこぼしたまま通知が途絶えてオートロードが止まるため、
      // 最新(末尾)のentryで現在の交差状態を判定する
      const latest = entries[entries.length - 1]
      // エラー中はオートロードしない(失敗する取得を自動で繰り返さない)。再開は再読み込みボタンから
      if (latest && latest.isIntersecting && !this.loading && !this.reachedLast && this.listError === 'none') {
        this.$emit('load-more')
      }
    }

    this.observer = new IntersectionObserver(observerCallback, {
      rootMargin: OBSERVER_ROOT_MARGIN,
    })
    this.observer.observe(this.$refs.sentinel as Element)
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    /**
     * sentinelの観測をやり直し、現在の交差状態でコールバックを再評価させる
     * (observe()し直すと現在の状態で初回通知が走ることを利用する)。
     * IntersectionObserverは交差状態の変化時にしか発火しないため、これをしないと
     * sentinelが画面内に見えたまま状態が変わらないケース(1ページ分が画面に収まる4列表示など)で、
     * スクロールしない限り次のページのオートロードが始まらない。
     */
    rearmObserver(): void {
      const sentinel = this.$refs.sentinel as Element | undefined
      if (!this.observer || !sentinel) {
        return
      }

      this.observer.unobserve(sentinel)
      this.observer.observe(sentinel)
    },
  },
})
